import { useState, type ReactElement, type ReactNode } from 'react';
import Tooltip from 'rc-tooltip';
import type { TooltipProps } from 'rc-tooltip/lib/Tooltip';
import { Close } from 'assets/icons';
import s from './Tooltip.module.scss';

interface ICTooltipProps extends Omit<TooltipProps, 'overlay' | 'children'> {
  children: ReactElement;
  overlay?: ReactNode;
  hide?: boolean;
}

export default function CTooltip({
  children,
  overlay,
  defaultVisible = false,
  placement = 'right',
  hide,
  ...props
}: ICTooltipProps) {
  const [isVisible, setIsVisible] = useState(defaultVisible);
  if (hide) return children;
  return (
    <Tooltip
      placement={placement}
      // rc-trigger calls it with the visibility (a boolean); its typings declare no argument.
      afterVisibleChange={(visible?: boolean) => {
        setIsVisible(Boolean(visible));
      }}
      mouseEnterDelay={0.5}
      visible={isVisible}
      defaultVisible={defaultVisible}
      trigger={['hover']}
      onVisibleChange={() => setIsVisible(!isVisible)}
      overlay={
        <div className={s.overlay}>
          <button
            type="button"
            className={s.closeBtn}
            onClick={(e) => {
              e.stopPropagation();
              setIsVisible(false);
            }}
          >
            <Close />
          </button>
          {overlay}
        </div>
      }
      {...props}
    >
      {children}
    </Tooltip>
  );
}
